<script setup>
import moment from "moment"
moment.locale('id');
</script>
<template>
    <div class="evaluation-table-container">
        <table class="evaluation-form-table">
            <tbody>
                <tr class="evaluation-table-heading">
                    <td colspan="2" style="background-color: #f8d7da;">Form Penilaian Calon Penanggung Jawab</td>
                </tr>
                <tr>
                    <td>Nama Calon PJO</td>
                    <td>{{dataPJO!==null&&dataPJO!==undefined?dataPJO.nama!==undefined&&dataPJO.nama!==null?dataPJO.nama:'-':'-'}}</td>
                </tr>
                <tr>
                    <td>Perusahaan</td>
                    <td>{{dataPJO!==null&&dataPJO!==undefined?dataPJO.perusahaan!==undefined&&dataPJO.perusahaan!==null?dataPJO.perusahaan:'-':'-'}}</td>
                </tr>
                <tr>
                    <td>Tanggal Presentasi</td>
                    <td>{{dataPJO!==null&&dataPJO!==undefined?dataPJO.tanggalPresentasi!==undefined&&dataPJO.tanggalPresentasi!==null?moment(dataPJO.tanggalPresentasi).format('LL'):'-':'-'}}</td>
                </tr>
                <tr class="evaluation-table-heading" v-if="!isResume">
                    <td>Keterangan</td>
                    <td>Skor</td>
                </tr>
                <tr v-if="!isResume">
                    <td>Tidak ada / tidak tersedia / tidak dijelaskan</td>
                    <td>0</td>
                </tr>
                <tr v-if="!isResume">
                    <td>Persyaratan belum memadai</td>
                    <td>1</td>
                </tr>
                <tr v-if="!isResume">
                    <td>Persyaratan cukup memadai tetapi masih perlu sedikit perbaikan</td>
                    <td>2</td>
                </tr>
                <tr v-if="!isResume">
                  <td>Persyaratan sudah memadai</td>
                  <td>3</td>
                </tr>
                <tr v-if="!isResume">
                    <td>Penilaian tidak dapat diaplikasikan</td>
                    <td>N/A</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
    name: "penilaianCalonPenanggungJawab",
    components: {
        // FontAwesomeIcon,
    },
    props:{
        dataPJO:{
            type:Object,
            required:true,
        },
        isResume:Boolean,
    }
};
</script>

<style></style>
